import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { InfoSection } from './components/InfoSection';
import { ProcessSection } from './components/ProcessSection';
import { BenefitsSection } from './components/BenefitsSection';
import { FaqSection } from './components/FaqSection';
import { TeamSection } from './components/TeamSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Interested in the Next Round of ICANN gTLDs? Greenberg Traurig Can Help';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'ICANN New gTLDs Next Round Contention Sets Auctions');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'ICANN New gTLDs Next Round Contention Sets Auctions';
      document.head.appendChild(meta);
    }
    // Google Tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-LV1XY4GMZT';
    document.head.appendChild(gtagScript);
    const gtagInline = document.createElement('script');
    gtagInline.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-LV1XY4GMZT');
    `;
    document.head.appendChild(gtagInline);
  }, []);
  return <div className="min-h-screen bg-gradient-to-br from-[#FAF9F5] to-[#F5F2EA]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <InfoSection data-id="element-4" />
        <ProcessSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <FaqSection data-id="element-7" />
        <TeamSection data-id="element-8" />
        <ContactSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}